'use strict';
import React, { PureComponent } from 'react'
import SelectorFecha from '../Common/SelectorFecha';


class FiltrosAdicionales extends PureComponent {
    constructor(props) {
        super(props);

        this.validarInput = this.validarInput.bind(this);
    }

    

    validarInput(event, nombreInput) {
        let valorInput = event.target.value;
        let regExp = "";
        let limiteCaracteres = 0;

        regExp = /^([1-9]|[1-9][0-9]+)$/ig;
        limiteCaracteres = 9;

        if ((!regExp.test(valorInput) && valorInput != "") || valorInput.length > limiteCaracteres) {
            event.preventDefault();
        } else {
            this.props.cambiarValorInput(undefined, nombreInput, valorInput);
        }
    }
    
    render() {
        const {
            checkSoloNoBalanceados,
            checkSoloIngresadosModificadosManualmente,
            checkSoloConfirmadosManualmente,
            checkSoloDadosBaja,
            checkFechaRendicion,
            classInputFecha,
            comboEstado,
            comboMoneda,
            comboSucursal,
            datosSucursales,
            datosEstados,
            datosMonedas,
            errorValidacion,
            estaDesplegado,
            inputFechaRendicionDesde,
            inputFechaRendicionHasta,
            inputIdAsiento
        } = this.props;

        //ACTIONS
        const {
            cambiarCheckAsientosContables,
            seleccionarOpcionCombo,
            validarInputFecha
        } = this.props;

        let classDisabled = {className: "form-control botonMenuProcesos--disabled"}
        let classInputFechaRendicionDesde = {className: classInputFecha + (errorValidacion.inputFechaRendicionDesde ? " AsientosContables__seccionFiltrosFechasSuperiores--errorValidacion" : "")}
        let classInputFechaRendicionHasta = {className: classInputFecha + (errorValidacion.inputFechaRendicionHasta ? " AsientosContables__seccionFiltrosFechasSuperiores--errorValidacion" : "")}

        let arraySucursales = [];
        let arrayEstados = [];
        let arrayMonedas = [];

        function mapArray(data,array) {
            data?.map((opt) => {
                array.push(
                <option key={opt.Id} value={opt.Id}>
                        {opt.Descripcion} 
                </option>);
            });
        }
 
        mapArray(datosSucursales,arraySucursales)
        mapArray(datosEstados,arrayEstados)
        mapArray(datosMonedas,arrayMonedas)

        return (
            <div className={"AsientosContables__filtrosAdicionales slider-tarjetas" + (estaDesplegado ? "" : " closed")}>
                <div className="AsientosContables--overflowHidden AsientosContables__filtrosAdicionalesContenedorSuperior">
                    <div className="AsientosContables--floatLeft">
                        <div className="AsientosContables__filtrosAdicionalesContenedorSucursalEstado">
                            <div className="seccionDatosGenerales__tituloSecundario">Sucursal</div>

                            <div className="seccionDatosGenerales__contenedorSelectSucursal">
                                <select 
                                    name="comboSucursal" 
                                    className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables--noMargin" 
                                    onChange={(event) => seleccionarOpcionCombo("comboSucursal", event.target.value, false)}
                                    value={comboSucursal} >
                                      <option value="0" key={0}> Todas</option>
                                      {arraySucursales}
                                </select>
                            </div>
                        </div>

                        <div className="AsientosContables__filtrosAdicionalesContenedorSucursalEstado">
                            <div className="seccionDatosGenerales__tituloSecundario">Estado</div>

                            <div className="seccionDatosGenerales__contenedorSelectSucursal">
                                <select 
                                    name="comboEstado" 
                                    className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables--noMargin" 
                                    onChange={(event) => seleccionarOpcionCombo("comboEstado", event.target.value, false)}
                                    value={comboEstado}>
                                      <option value="0" key={0}>Todos</option>
                                      {arrayEstados}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="AsientosContables--floatLeft AsientosContables__filtrosAdicionalesIdAsientoMoneda">
                        <div className="AsientosContables__filtrosAdicionalesIdAsientoMoneda AsientosContables__filtrosAdicionalesContenedorIdAsientoMoneda">
                            <div>
                                <div className="seccionDatosGenerales__tituloSecundario">ID de asiento:</div>
                                <input type="text"  
                                    onChange={(event) => this.validarInput(event, "inputIdAsiento")}
                                    value={inputIdAsiento}
                                    className="seccionDatosGenerales__inputSelect AsientosContables__filtrosAdicionalesIdAsientoMoneda" 
                                    name="inputIdAsiento" 
                                    id="inputIdAsiento" />
                            </div>
                        </div>
                        <div className="AsientosContables__filtrosAdicionalesIdAsientoMoneda AsientosContables__filtrosAdicionalesContenedorIdAsientoMoneda">
                            <div className="seccionDatosGenerales__tituloSecundario">Moneda de selección</div>

                            <div className="seccionDatosGenerales__contenedorSelectSucursal">
                                <select 
                                    name="comboMoneda" 
                                    className="seccionDatosGenerales__inputSelect seccionDatosGenerales__sucursalSelect AsientosContables__filtrosAdicionalesIdAsientoMoneda" 
                                    onChange={(event) => seleccionarOpcionCombo("comboMoneda", event.target.value, false)}
                                    value={comboMoneda} >
                                        <option value="0" key={0}>Todas</option>
                                        {arrayMonedas}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="AsientosContables--floatLeft AsientosContables__filtrosAdicionalesContenedorCheckboxes">
                        <div className="AsientosContables__filtrosAdicionalesCheckboxesIndividuales">
                            <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                <input id={"checkSoloNoBalanceados"} type="checkbox" checked={checkSoloNoBalanceados} onChange={() => cambiarCheckAsientosContables("checkSoloNoBalanceados", !checkSoloNoBalanceados)} />
                                <label className={"label-primary Tarjetas-checkboxLabel" + (checkSoloNoBalanceados ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkSoloNoBalanceados"}></label>
                            </div>
                            <label className={"label-primary seccionDatosGenerales__label AsientosContables__tituloCheckBoxes"}>Sólo no balanceados</label>
                        </div>

                        <div className="AsientosContables__filtrosAdicionalesCheckboxesIndividuales">
                            <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                <input id={"checkSoloIngresadosModificadosManualmente"} type="checkbox" checked={checkSoloIngresadosModificadosManualmente} onChange={() => cambiarCheckAsientosContables("checkSoloIngresadosModificadosManualmente", !checkSoloIngresadosModificadosManualmente)} />
                                <label className={"label-primary Tarjetas-checkboxLabel" + (checkSoloIngresadosModificadosManualmente ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkSoloIngresadosModificadosManualmente"}></label>
                            </div>
                            <label className={"label-primary seccionDatosGenerales__label AsientosContables__tituloCheckBoxes"}>Sólo ingresados/modificados manualmente</label>
                        </div>

                        <div className="AsientosContables__filtrosAdicionalesCheckboxesIndividuales">
                            <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                <input id={"checkSoloConfirmadosManualmente"} type="checkbox" checked={checkSoloConfirmadosManualmente} onChange={() => cambiarCheckAsientosContables("checkSoloConfirmadosManualmente", !checkSoloConfirmadosManualmente)} />
                                <label className={"label-primary Tarjetas-checkboxLabel" + (checkSoloConfirmadosManualmente ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkSoloConfirmadosManualmente"}></label>
                            </div>
                            <label className={"label-primary seccionDatosGenerales__label AsientosContables__tituloCheckBoxes"}>Sólo confirmados manualmente</label>
                        </div>

                        <div>
                            <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                                <input id={"checkSoloDadosBaja"} type="checkbox" checked={checkSoloDadosBaja} onChange={() => cambiarCheckAsientosContables("checkSoloDadosBaja", !checkSoloDadosBaja)} />
                                <label className={"label-primary Tarjetas-checkboxLabel" + (checkSoloDadosBaja ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkSoloDadosBaja"}></label>
                            </div>
                            <label className={"label-primary seccionDatosGenerales__label AsientosContables__tituloCheckBoxes"}>Sólo dados de baja</label>
                        </div>
                    </div>
                </div>
                
                <div className="AsientosContables__filtrosAdicionalesContenedorFechaRendicionCore">
                    <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                        <input id={"checkFechaRendicion"} type="checkbox" checked={checkFechaRendicion} onChange={() => cambiarCheckAsientosContables("checkFechaRendicion", !checkFechaRendicion)} />
                        <label className={"label-primary Tarjetas-checkboxLabel" + (checkFechaRendicion ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkFechaRendicion"}></label>
                    </div>
                    <label className={"label-primary seccionDatosGenerales__label AsientosContables__tituloCheckBoxes"}>Fecha de rendición al CORE</label>
                </div>


                <div className={"AsientosContables__filtrosAdicionalesContenedorDesdeHastaRendicionCore" + (checkFechaRendicion ? "" : " disableDiv")}>
                    <div>
                        <div className={"AsientosContables--floatLeft"}>
                            <SelectorFecha
                                nombreInput={"inputFechaRendicionDesde"}
                                claseContainer={"AsientosContables__seccionMasFiltrosFecha AsientosContables__seccionFiltrosFechas AsientosContables--floatLeft AsientosContables__fechaDesdeMargin" + (checkFechaRendicion ? "" : " AsientosContables__seccionFiltrosFechas--disabled")}
                                classTitulo={"seccionDatosGenerales__tituloSecundario"}
                                errorFormatoFecha={null}
                                fecha={inputFechaRendicionDesde}
                                funcionSeleccion={validarInputFecha}
                                inputProps={checkFechaRendicion ? classInputFechaRendicionDesde : classDisabled}
                                maxToday={true}
                                titulo={"Desde"}
                            />
                        </div>

                        <div className={"AsientosContables--floatLeft"}>
                            <SelectorFecha 
                                nombreInput={"inputFechaRendicionHasta"}
                                claseContainer={"AsientosContables__seccionMasFiltrosFecha AsientosContables__seccionFiltrosFechas AsientosContables--floatLeft" + (checkFechaRendicion ? "" : " AsientosContables__seccionFiltrosFechas--disabled")}
                                classTitulo={"seccionDatosGenerales__tituloSecundario"}
                                errorFormatoFecha={null}
                                estaDeshabilitado={!checkFechaRendicion}
                                fecha={inputFechaRendicionHasta}
                                funcionSeleccion={validarInputFecha}
                                inputProps={checkFechaRendicion ? classInputFechaRendicionHasta : classDisabled}
                                maxToday={true}
                                titulo={"Hasta"}
                            />
                        </div>
                    </div>

                    {errorValidacion.inputFechaRendicionContenedor &&
                        <div>
                            <label className="error AsientosContables--errorWidth-contenedor">{errorValidacion.inputFechaRendicionContenedor}</label>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default FiltrosAdicionales;